import { graphql, useStaticQuery, Link } from "gatsby"
import React from "react"
import Headroom from "../headroom"
import styled from "@emotion/styled"
import Container from "./container"
import Search from "./search"
import { Logo } from "./logo"
import VerticalAlign from "./verticalAlign"
import Img from "gatsby-image"
import { Socials } from "./footer";
import { FiMenu } from "react-icons/fi"
import { FaShoppingCart } from "react-icons/fa";

import {
  // Heading, 
  Box,
  Grid,
  Link as ChakraLink,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Heading,
  List,
  ListItem,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  Text, 
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  PseudoBox,
  Input,
} from "@chakra-ui/core";

import theme from "../theme";

const Styles = styled.div`
  span {
    display: block;
    margin: 0 auto;
    font-size: 15px;
  }

  .my-cart-botton {
    transition: all 0.3s ease;
    color: ${ theme.blue };

    svg {
      color: #171923;
    }
    &:hover {
      svg {
        color: ${ theme.blue};
      }

      .my-circle {
        color: ${ theme.yellow};
        background-color: ${ theme.turqoise};
        border-color: ${ theme.yellow };
      }
    }
  }
`
export default class Header extends React.Component {
  constructor(props) {
    super()
    this.state = {}
    this.state.width = 800;
    
  }

  componentDidMount() {
    if (typeof window !== undefined) {
      window.onresize = this.links.bind(this)
      this.links()
      
      // setTimeout( this.setCartItems.bind(this) )
      
    }
  }

  // setCartItems () {
  //   if (window.Snipcart) {
  //     this.setState({
  //       cartItems: window.Snipcart.store.getState().cart.items.length
  //     })
  //   } else {
  //     document.addEventListener('snipcart.ready', this.setCartItems.bind(this ));
  //   }
    
    
  // }


  links() {
    if (window.innerWidth < 940) {
      this.setState({
        links: <MyDrawer />
      })
    } else {
      this.setState({
        links: <Box pr={[0, 4]} height="100%" color="gray.900"><VerticalAlign>
            <ChakraLink as={ Link } to=""  ml={5} _hover={{ color: theme.blue, textDecoration: "none" }} rounded="sm">
              Home
            </ChakraLink>

 
            <ChakraLink as={ Link } to="about"  ml={5} _hover={{ color: theme.blue, textDecoration: "none" }} rounded="sm">
              About
            </ChakraLink>
          
          

          
            <ChakraLink as={ Link } to="catalog"  ml={5} _hover={{ color: theme.blue, textDecoration: "none" }} rounded="sm">
              Catalog
            </ChakraLink>

            <ChakraLink as={ Link } to="store"  ml={5} _hover={{ color: theme.blue, textDecoration: "none" }} rounded="sm">
              Store
            </ChakraLink>

            <ChakraLink as={ Link } to="subscribe"  ml={5} _hover={{ color: theme.blue, textDecoration: "none" }} rounded="sm">
              Subscribe
            </ChakraLink>

            <ChakraLink as={ Link } to="blog"  ml={5} _hover={{ color: theme.blue, textDecoration: "none" }} rounded="sm">
              Blog
            </ChakraLink>
          


            <ChakraLink as={ Link } to="contact"  ml={5} _hover={{ color: theme.blue, textDecoration: "none" }} rounded="sm">
              Contact
            </ChakraLink>
          


          <Box className="snipcart-checkout my-cart-botton" color="gray.800" cursor="pointer" display="inline" ml={5} position="relative" bottom="1px">
            {/* <Box className="my-circle snipcart-items-count" float="right" fontSize="11px" borderRadius="50%" bg={ "gray.100" } width="15px" height="15px" textAlign="center" color={ theme.turqoise } position="relative" right="3px" borderWidth="1px" paddingBottom="1px" >
              {
                this.state.cartItems
              }
              </Box> */}
            <FaShoppingCart style={{ display: "inline" }} />

          </Box>

        </VerticalAlign>
        </Box>
      })


    }
  }

  
  render() {
    let myDisable = this.state.open ? true : false;
    return (
      <Headroom wrapperStyle={{ position: "fixed", zIndex: 200, width: "100%" }} disable={ myDisable }>

      <Box bg="gray.100" height={[80]} width="100vw" zIndex="1000" borderBottomWidth="1px" borderColor="gray.900">

        <Styles>
          <Grid templateColumns={["80px calc(100% - 180px) 60px", "80px 120px calc(100% - 240px)"]} gap="10px" maxWidth="1130px" margin="0 auto" padding={["0px 14px", "0px 14px", "0px 14px", "0px"]}>
            <Box zIndex="10">
              <VerticalAlign>
                <Link to="/">
                  <Logo />
                </Link>
              </VerticalAlign>
            </Box>

            <Box position="relative">
            <Box height="100%">
              <VerticalAlign>
                <Search />
              </VerticalAlign>

              </Box>
            </Box>

            <Box textAlign="right" fontSize="18px">
              {
                this.state.links
              }
            </Box>
          </Grid>
        </Styles>
      </Box>
      </Headroom>

    )
  }
}



function MyDrawer() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <>
      <VerticalAlign>
        <Button variant="outline" borderColor="none" ref={btnRef} color="gray.900" onClick={onOpen} float="right" padding="9px" rounded="full" _hover={{bg: "gray.900", color: "gray.100"}} transition="all 0.2s ease" cursor="pointer">
        <FiMenu />
        </Button> 
          
       
      </VerticalAlign>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Box className="snipcart-checkout" display="inline" position="relative" bottom="1px" cursor="pointer">

              Cart

                <FaShoppingCart style={{ display: "inline", marginLeft: 12 }} />


              {/* <Box className="snipcart-items-count snipcart-checkout" display="inline-block" ml={2} borderRadius="50%" bg="red.500" fontSize="17px" width="24px" height="24px" textAlign="center" color="white" position="relative" >
                  
              </Box> */}
            </Box>

          </DrawerHeader>

          <DrawerBody padding={0}>
            <Link to="/">
              <PseudoBox p={"6px 24px"} _hover={{ bg: "gray.200", }}>
                Home
            </PseudoBox>
            </Link>

            <Link to="/about">
              <PseudoBox p={"6px 24px"} _hover={{ bg: "gray.200", }}>
                About
            </PseudoBox>
            </Link>

            <Link to="/catalog">
              <PseudoBox p={"6px 24px"} _hover={{ bg: "gray.200", }}>
                Catalog
              </PseudoBox>
            </Link>


            <Link to="/shop">
              <PseudoBox p={"6px 24px"} _hover={{ bg: "gray.200", }}>
                Shop
              </PseudoBox>
            </Link>

            <Link to="/subscribe">
              <PseudoBox p={"6px 24px"} _hover={{ bg: "gray.200", }}>
                Subscribe
              </PseudoBox>
            </Link>

            <Link to="/blog">
              <PseudoBox p={"6px 24px"} _hover={{ bg: "gray.200", }}>
                Blog
              </PseudoBox>
            </Link>

         


            <Link to="/contact">
              <PseudoBox p={"6px 24px"} _hover={{ bg: "gray.300", }}>
                Contact
              </PseudoBox>
            </Link>

          </DrawerBody>

          <DrawerFooter textAlign="left" display="block">
            <Socials />
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}



